module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-cta-banner"
  }, [_c('div', {
    staticClass: "custom-cta-banner__container"
  }, [_c('div', {
    staticClass: "custom-cta-banner__title"
  }, [_vm._v(_vm._s(_vm.props.title))])]), _c('div', {
    staticClass: "custom-cta-banner__content"
  }, [_c('div', {
    staticClass: "custom-cta-banner__images"
  }, _vm._l((_vm.props.images), function(image, i) {
    return _c('img', {
      key: "image " + i,
      attrs: {
        "src": image.src,
        "alt": image.alt
      }
    })
  })), _c('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "id": "invisalign_video",
      "src": "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fsukoffortho%2Fvideos%2F2230389760310151%2F&show_text=0&width=560",
      "width": "50%",
      "height": "315",
      "scrolling": "no",
      "frameborder": "0",
      "allowTransparency": "true",
      "allowFullScreen": "true",
      "title": "Facebook Video"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0668d6ae","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-cta-banner/custom-cta-banner.pug
// module id = 580
// module chunks = 1